import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import logo from "../../assets/Logo_Prosperidad_Social.png";
import logo472 from "../../assets/logo_427.png";

const ExportarResumenAprobados = ({ data = [] }) => {

    const handleDownloadExcel = async () => {
        if (!data || data.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Resumen KOKAN");

        // 🔥 === LOGOS ===

        // 🔹 Logo 1
        const response1 = await fetch(logo);
        const blob1 = await response1.blob();
        const buffer1 = await blob1.arrayBuffer();

        const imageId1 = workbook.addImage({
            buffer: buffer1,
            extension: "png",
        });

        // 🔹 Logo 2
        const response2 = await fetch(logo472);
        const blob2 = await response2.blob();
        const buffer2 = await blob2.arrayBuffer();

        const imageId2 = workbook.addImage({
            buffer: buffer2,
            extension: "png",
        });

        // 🔥 DIMENSIONES DE COLUMNAS
        worksheet.getColumn(1).width = 25; // A
        worksheet.getColumn(2).width = 20; // B
        worksheet.getColumn(3).width = 30; // C
        worksheet.getColumn(4).width = 25; // D

        // 🔥 ALTURA FILAS
        worksheet.getRow(1).height = 25;
        worksheet.getRow(2).height = 25;
        worksheet.getRow(3).height = 20;

        // 🔥 LOGO 1 (A1:A3)
        worksheet.mergeCells("A1:A3");

        worksheet.addImage(imageId1, {
            tl: { col: 0.2, row: 0.9 }, // leve centrado
            ext: { width: 200, height: 70 }, // 🔥 control total
        });

        // 🔥 LOGO 2 (B1:B3)
        worksheet.mergeCells("B1:B3");

        worksheet.addImage(imageId2, {
            tl: { col: 1.7, row: 1 }, // centrado visual
            ext: { width: 150, height: 30 },
        });

        // 🔥 TITULO (C1:D2)
        worksheet.mergeCells("C1:D2");

        const titleCell = worksheet.getCell("C1");
        titleCell.value = "RESUMEN APROBADOS KOKAN";
        titleCell.font = {
            size: 14,
            bold: true,
            color: { argb: "FF1B5E20" },
        };
        titleCell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        // 🔥 FECHA (C3:D3)
        worksheet.mergeCells("C3:D3");

        const dateCell = worksheet.getCell("C3");
        dateCell.value = `Fecha de consulta: ${new Date().toLocaleDateString()}`;
        dateCell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        // 🔥 ESPACIO
        worksheet.addRow([]);

        // 🔥 CABECERA
        const headerRow = worksheet.addRow([
            "Municipio",
            "Encuestador",
            "Cédula encuestador",
            "Total encuestas",
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF2E7D32" },
            };
            cell.alignment = { horizontal: "center" };
            cell.border = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // 🔥 DATA (RESUMEN)
        data.forEach((item) => {
            const row = worksheet.addRow([
                item.municipio,
                item.encuestador,
                item.cedula,
                item.total,
            ]);

            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                };
            });
        });

        // 🔥 AJUSTE COLUMNAS
        worksheet.columns = [
            { width: 25 },
            { width: 30 },
            { width: 20 },
            { width: 18 },
        ];

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer]),
            `Resumen_KOKAN_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
    };

    return (
        <Button
            icon={<FileExcelOutlined />}
            style={{ backgroundColor: "#1565c0", borderColor: "#1565c0", color: "white" }}
            onClick={handleDownloadExcel}
        >
            Exportar Resumen
        </Button>
    );
};

export default ExportarResumenAprobados;